import axios from 'axios';
import refreshAccessToken from './TokenService';

export const initialAuthState = {
  userId: 4,
  userName: 'admin',
  companyCode: 'WAY4TRACK',
  unitCode: 'WAY4',
};

const ApiService = (() => {
  const axiosInstance = axios.create({
    baseURL:
      process.env.REACT_APP_API_BASE_URL,
    //  ||
    // 'http://localhost:3000/api/',
    // 'https://sharontelematics.org/api/',
    withCredentials: true,
  });

  // =========================
  // REQUEST INTERCEPTOR
  // =========================
  axiosInstance.interceptors.request.use(
    (config) => {
      if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
      }

      // const role = localStorage.getItem('role');

      // // CEO ONLY JWT
      // if (role === 'CEO') {
      //   const token = sessionStorage.getItem('accessToken');

      //   if (token) {
      //     config.headers.Authorization = `Bearer ${token}`;
      //   }
      // }

      return config;
    },
    (error) => Promise.reject(error)
  );

  // =========================
  // RESPONSE INTERCEPTOR
  // =========================
  axiosInstance.interceptors.response.use(
    (response) => response.data,

    async (error) => {
      const originalRequest = error.config || {};
      const role = localStorage.getItem('role');

      // ONLY CEO refresh flow
      if (
        error?.response?.status === 401 &&
        role === 'CEO' &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        try {
          const newToken = await refreshAccessToken();

          if (newToken) {
            // sessionStorage.setItem('accessToken', newToken);

            originalRequest.headers =
              originalRequest.headers || {};

            originalRequest.headers.Authorization =
              `Bearer ${newToken}`;

            return axiosInstance(originalRequest);
          }

          // refresh failed → logout
          sessionStorage.removeItem('accessToken');
          localStorage.clear();
          // localStorage.removeItem('role');
          // localStorage.removeItem('userId');

          window.location.href = '/';
          return Promise.reject(error);
        } catch (err) {
          sessionStorage.removeItem('accessToken');
          localStorage.clear();
          // localStorage.removeItem('role');
          // localStorage.removeItem('userId');

          window.location.href = '/';
          return Promise.reject(err);
        }
      }

      return Promise.reject(error?.response || error.message);
    }
  );

  return {
    get: (url, params) =>
      axiosInstance.get(url, { params }),

    post: (url, data, config = {}) =>
      axiosInstance.post(url, data, config),

    patch: (url, data) =>
      axiosInstance.patch(url, data),

    put: (url, data) =>
      axiosInstance.put(url, data),

    delete: (url) =>
      axiosInstance.delete(url),
  };
})();

export default ApiService;














// // src/services/ApiService.js

// import axios from 'axios';
// import { param } from 'framer-motion/client';

// export const initialAuthState = {
//   userId: 4,
//   userName: 'admin',
//   companyCode: 'WAY4TRACK',
//   unitCode: 'WAY4',
// };

// const ApiService = (() => {
//   const axiosInstance = axios.create({
//     baseURL:
//       // process.env.REACT_APP_API_BASE_URL || 'https://sharontelematics.org/api/', // Replace with your API base URL
//       process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/', // Replace with your API base URL
//     // timeout: 100000000, // Request timeout in milliseconds
//     withCredentials: true,
//   });

//   // Interceptor for handling requests

//   axiosInstance.interceptors.request.use((config) => {
//     if (!(config.data instanceof FormData)) {
//       config.headers['Content-Type'] = 'application/json';
//     }

//     return config;
//   });
//   // axiosInstance.interceptors.request.use((config) => {
//   //   if (config.data instanceof FormData) {
//   //     config.headers['Content-Type'] = 'multipart/form-data'; // Set for FormData
//   //   } else {
//   //     config.headers['Content-Type'] = 'application/json'; // Default
//   //   }
//   //   return config;
//   // });

//   // Interceptor for handling responses
//   axiosInstance.interceptors.response.use(
//     (response) => response.data,
//     (error) => {
//       console.error(
//         'API error:',
//         error.response ? error.response.data : error.message
//       );
//       return Promise.reject(error.response || error.message);
//     }
//   );

//   return {
//     get: (url, params) => axiosInstance.get(url, { params }),
//     post: (url, data) => axiosInstance.post(url, data),
//     patch: (url, data) => axiosInstance.patch(url, data),
//     put: (url, data) => axiosInstance.put(url, data),
//     delete: (url) => axiosInstance.delete(url),
//   };
// })();

// export default ApiService;
